import { formatMoney } from 'accounting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle, faCopy, faPencilAlt } from '@fortawesome/pro-light-svg-icons'
import { faCircle as faCircleSolid } from '@fortawesome/pro-solid-svg-icons'

import { Box, Link, Text } from '@domain-group/suit-theme'

import type { ProviderPriceListItemModel } from '@models/providerPriceListItem'

import { confirmDelete } from '@functions/entity'

import useProviderPriceListItem from '@hooks/useProviderPriceListItem'

import DeleteIcon from '@components/PriceListManager/components/DeleteIcon'

interface PriceListItemProps {
  callbacks: {
    selectPriceListItem: VoidFunction,
  },
  hidden: boolean,
  isMaster: boolean,
  last: boolean,
  providerPriceListItem: ProviderPriceListItemModel,
  selected: boolean,
}

const PriceListItem = (props: PriceListItemProps) => {
  const {
    callbacks: {
      selectPriceListItem,
    },
    hidden = false,
    isMaster,
    last = false,
    providerPriceListItem,
    selected = false,
  } = props

  const providerPriceListItemPayload = useProviderPriceListItem(providerPriceListItem)
  const {
    callbacks: {
      deleteProviderPriceListItem: deleteFn,
      duplicateProviderPriceListItem: duplicateFn,
      toggleItemVisibility: toggleVisibilityFn,
    },
    providerPriceListItem: {
      price,
      quantity,
    },
  } = providerPriceListItemPayload

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure?',
      entityName: 'Price List Item',
    },
  }

  return (
    <Box borderBottom={last ? 'none' : '1px dashed'} borderColor="lineColor" paddingY="medium">
      <Box color={selected ? 'blue' : 'lightGrey'} width="auto">
        <FontAwesomeIcon icon={selected ? faCircleSolid : faCircle} />
      </Box>

      {/* @ts-expect-error TS2322 */}
      <Box marginLeft="large" textDecoration="line-through">
        <Text color={hidden ? 'lightGrey' : 'bodyFontColor'}>{quantity}</Text>

        <Text color="lightGrey" marginX="medium">-</Text>

        <Text color={hidden ? 'lightGrey' : 'bodyFontLightColor'} marginRight="large">
          {formatMoney(price)}
        </Text>
      </Box>

      <Box marginLeft="auto" width="fit-content">
        <Box width="fit-content">
          {!hidden && (
            <Link as="a" greyLink onClick={selectPriceListItem} textProps={{ marginRight: 'medium' }}>
              <FontAwesomeIcon icon={faPencilAlt} />
            </Link>
          )}

          {isMaster && (
            <Link
              as="a"
              greyLink
              onClick={() => duplicateFn({
                include_provider_price_list_item_options: true,
                include_provider_price_list_item_option_values: true,
              })}
              textProps={{ marginRight: 'medium' }}
            >
              <FontAwesomeIcon icon={faCopy} />
            </Link>
          )}

          <Link
            as="a"
            greyLink
            onClick={isMaster ? () => confirmDelete(confirmDeletePayload) : () => toggleVisibilityFn()}
          >
            <DeleteIcon hidden={hidden} isMaster={isMaster} />
          </Link>
        </Box>
      </Box>
    </Box>
  )
}

export default PriceListItem
